module.exports = __webpack_public_path__ + "img/equation_sqr1-1.a7684f05.svg";